<template>
	<div>
		
		<div class="uk-container-expand shopScreen">
			<appNav></appNav>
		</div>



		<div class="uk-container shopScreen">
			<div class="uk-h3">{{ ms }}</div>
			<hr class="uk-divider-icon">

			<div class="uk-grid-large" uk-grid>

					<div class="uk-width-auto rightBorder uk-visible@s">
							<div class="leftNavBar">

								<ul class="uk-list uk-list-divider uk-text-left" uk-sticky>								

									<li><a href="#rostov" class="uk-button uk-button-default uk-button-small uk-margin-top" uk-scroll>Ростов-на-Дону</a></li>

									<p class="city uk-margin-remove"> <i class="mdi mdi-barley"></i>Фирменные магазины</p>

									<li><a href="#evd" class="uk-button uk-button-text tc" uk-scroll>ул. Евдокимова</a></li>
									<li><a href="#v" class="uk-button uk-button-text tc" uk-scroll>пр. Ворошиловский</a></li>
									<li><a href="#g" class="uk-button uk-button-text tc" uk-scroll>ул. Горького</a></li>

									<p class="city uk-margin-remove"> <i class="mdi mdi-barley"></i>Другие магазины</p>
									<li><a href="#tcRostov" class="uk-button uk-button-text tc" uk-scroll>Показать</a></li>

									<li><a href="#other" class="uk-button uk-button-default uk-button-small uk-margin-top" uk-scroll>Другие города</a></li>
									
								</ul>

								
							</div>
							
					</div>

					<div class="uk-width-expand">

							<div>
<div id="rostov"></div>
<div class="uk-h2">Сеть фирменных кафе-пекарен «ГРIДНЕВЪ-ХЛЕБЪ»</div>

										<article

										class="uk-article"
										v-for="shop in getShops" :key="shop.id"
										>
										
										<div :id="shop.scrolll"></div>

										<div class="uk-h2">{{ shop.name }} </div>

										<div class="uk-label">{{ shop.street }}</div>
										<p class="uk-article-meta timeWork uk-flex uk-flex-middle"><i class="mdi mdi-clock-outline"></i> {{ shop.timeWork }}</p>


										<a v-if="shop.tel" :href="shop.tel" class="uk-button uk-button-text callShop">
										<i class="mdi mdi-phone-in-talk"></i> {{ shop.phone }}
										</a>
										<div class="textCall">	{{ shop.textCall }}</div>


										<div class="uk-h4 uk-margin-remove photoTitle">{{ shop.photoTitle }}</div>

										<div class="uk-child-width-1-4@m uk-grid-small" uk-grid uk-lightbox="animation: slide">
										<div >
										<a class="uk-inline" :href="shop.picUrl" :data-caption="shop.onPhotoDescr">
										<img :src="shop.picUrl" alt="">
										</a>
										</div>
										</div>
										<ul uk-accordion="collapsible: true">
										<li>
										<a class="uk-accordion-title" href="#">Показать на карте</a>
										<div class="uk-accordion-content">
										<div v-html="shop.map"></div>
										</div>
										</li>
										</ul>
										</article> 

										<p><i  class="mdi mdi-alert-box-outline thisPhone"></i> По телефонам кафе-пекарен Вы всегда сможете получить консультацию по ассортименту нашей продукции и ее наличию в торговой точке, сделать предзаказ (на определённые позиции) и уточнить наше точное расположение, а также часы работы</p>

<br>
<br>
<hr>
								<div id="tcRostov" class="tcRostov">
									<div class="uk-h2">Магазины в которых представлена наша продукция <br> (Ростов-на-Дону)</div>
									<div class="uk-child-width-1-5@m uk-grid-small uk-grid-match " uk-grid>
									<div v-for="(tcone, inx) in tc" :key="inx">
											<div class="uk-card uk-card-default uk-card-body">
													<img :src="tcone.picUrl" alt="">
											</div>
									</div>
							</div>
			
						
								</div>


<br>
<br>

								<div id="other" >
                 <hr class="uk-divider-icon">
									<div class="uk-h2">Другие города</div>

									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ aks }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="aksa in getAksay" :key="aksa.id"><span>{{ aksa.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ aksa.street }}</li>
										</ul>
									</div>

									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ bat }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="batsk in getBataysk" :key="batsk.id"><span>{{ batsk.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ batsk.street }}</li>
										</ul>
									</div>

									<hr>
									<div v-for="ad in getAdigeya" :key="ad.id">
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ ad.city}}</div>
										<ul class="uk-list uk-list-striped">
												<li> <span>{{ ad.shop }}</span> <i class="mdi mdi-arrow-right"></i> {{ ad.street }}  </li>
										</ul>
									</div>

									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ volg }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="vol in getVolgograd" :key="vol.id"><span>{{ vol.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ vol.street }}</li>
										</ul>
									</div>


									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ kr }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="krasn in getKrasnodar" :key="krasn.id"><span>{{ krasn.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ krasn.street }}</li>
										</ul>
									</div>

									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ novsh }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="novshaht in getNovoshahtinsk" :key="novshaht.id"><span>{{ novshaht.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ novshaht.street }}</li>
										</ul>
									</div>

									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ tag }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="tagr in getTaganrog" :key="tagr.id"><span>{{ tagr.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ tagr.street }}</li>
										</ul>
									</div>

									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ novch }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="novoch in getNovocherkask" :key="novoch.id"><span>{{ novoch.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ novoch.street }}</li>
										</ul>
									</div>

									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ shahti }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="shahti in getSahti" :key="shahti.id"><span>{{ shahti.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ shahti.street }}</li>
										</ul>
									</div>

									<hr>
									<div>
										<div class="uk-h3"><i class="mdi mdi-cart cartCity"></i> {{ chaltir }}</div>
										<ul class="uk-list uk-list-striped" >
												<li v-for="chaltr in getChaltir" :key="chaltr.id"><span>{{ chaltr.point }}</span> <i class="mdi mdi-arrow-right"></i> {{ chaltr.street }}</li>
										</ul>
									</div>


								</div>


							</div>
					</div>
			</div>


			<router-link uk-scroll to="" ><a href="#rostov" uk-scroll class="uk-button uk-button-text"><i class="mdi mdi-chevron-up"></i> наверх</a></router-link>

		</div>

		<br>
		<br>
		
	</div>
</template>


<script>
import appNav from '@/components/Nav'

export default {
	data () {
		return {
			ms: 'Магазины',
			volg: 'Волгоград',
			kr: 'Краснодар',
			novsh: 'Новошахтинск',
			tag: 'Таганрог',
			novch: 'Новочеркасск',
			shahti: 'Шахты',
			aks: 'Аксай',
			bat: 'Батайск',
			chaltir: 'c. Чалтырь',
			tc: [
					{	picUrl: '/img/logo/00.png' },
					{	picUrl: '/img/logo/01.jpg' },
					{	picUrl: '/img/logo/02.png' },
					{	picUrl: '/img/logo/03.jpeg' },
					{	picUrl: '/img/logo/04.jpg' },
					{	picUrl: '/img/logo/05.png' },
					{	picUrl: '/img/logo/06.png' },
					{	picUrl: '/img/logo/08.png' }
			]
		}
	},
	computed: {
		getShops () {
			return this.$store.getters.getShops
		},
		getAksay () {
			return this.$store.getters.getAksay
		},
		getBataysk () {
			return this.$store.getters.getBataysk
		},
		getAdigeya () {
			return this.$store.getters.getAdigeya
		},
		getVolgograd () {
			return this.$store.getters.getVolgograd
		},
		getKrasnodar () {
			return this.$store.getters.getKrasnodar
		},
		getNovoshahtinsk () {
			return this.$store.getters.getNovoshahtinsk
		},
		getTaganrog () {
			return this.$store.getters.getTaganrog
		},
		getNovocherkask () {
			return this.$store.getters.getNovocherkask
		},
		getSahti () {
			return this.$store.getters.getSahti
		},
		getChaltir () {
			return this.$store.getters.getChaltir
		}
	},
	created() {
			window.scrollTo(0, 0);
		},
	components: {
		appNav
	}
} 
</script>



<style>

.shopScreen .uk-article {
	margin-top: 5px !important;
}

.shopScreen .uk-article .uk-h2{
	/* margin-top: 20px !important; */
}

.shopScreen .uk-navbar-container:not(.uk-navbar-transparent) {
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.0001) 0%, #ecf0f1 150.79%);
}

.shopScreen .uk-navbar-nav>li>a {
	font-weight: 500;
}

.shopScreen .leftNavBar{
 width: 200px;
 padding-right: 5px;
}

.rightBorder {
  border-right: 1px solid #ccc;
}

.city {
	color:#B94547;
	font-weight: 500;
	padding-top: 25px;
}

.timeWork {
	color:#2c3e50;
	font-weight: 500;
}

.timeWork i {
	font-size: 25px;
	margin-right: 10px;
}

.callShop {
	font-size: 18px;
}

.callShop {
	color:#B94547;
}

.textCall {
	margin-top: 10px;
	margin-left: 25px;
	font-size: 15px;
	line-height: 18px;
}

.tc {
	display: block;
	text-align: left;
}

#other span{
	font-weight: 500;
}

#other i.cartCity {
	color:#777;
	margin-right: 10px;
	font-size: 22px;
}

.logos img{
	width: 100px;
}

.photoTitle {
	margin-bottom: 10px !important;
}

.thisPhone  {
	color:#B94547;
}
</style>